import {setProjectList} from "../actions";
import Facade from "../Facade";

export default function runRefreshProjectList ( dispatch )
{
  //刷新
  Facade.gw.getProjectList((list) => {
    dispatch(setProjectList(list));
  });
}